import { Certificate } from '@revenuemarket/bank';
import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

export interface GetCertificatesResponse extends ResponseBase {
  data: {
    certificates: Certificate[];
  };
}

/**
 * 등록된 인증서 조회
 * @link https://bank.dev.clobe.ai/swagger-ui/index.html#/Certificate%20API/getCompanyCertificates_1
 *
 * @param companyId
 * @returns
 */
export default function getCertificates(companyId: string) {
  return API.get<GetCertificatesResponse>(`/api/v3/companies/${companyId}/certificates`);
}
